<template>
  <div style="width:100%">
    <audit-logs></audit-logs>
  </div>
</template>

<script>
import AuditLogs from "@/components/reminders/AuditLogs"

export default {
  components: {
    AuditLogs
  }
}
</script>